import { useNavigate, useSearch } from '@tanstack/react-router';

import type {
  SupplyAppsSortDirection,
  SupplyAppsSortProperty,
  SupplyInventoryAppStatus,
} from './model';
import { defaultSupplyAppsListFilter } from './model';
import { parseSupplyAppsRouteSearch, serializeSupplyAppsRouteSearch } from './appsRouteSearch';

export function useAppsRouteFilters(publisherScoped = false) {
  const navigate = useNavigate({
    from: publisherScoped ? '/supply/publishers/$publisherId/details/apps' : '/supply/apps/',
  });
  const search = useSearch({ strict: false });
  const filter = parseSupplyAppsRouteSearch(search, publisherScoped);
  const update = (next: typeof filter) => {
    void navigate({ search: serializeSupplyAppsRouteSearch(next, publisherScoped), replace: true });
  };
  return {
    filter,
    setSearch: (searchTerm: string) => {
      update({ ...filter, searchTerm, page: 0 });
    },
    setStatuses: (statuses: SupplyInventoryAppStatus[]) => {
      update({ ...filter, statuses, page: 0 });
    },
    setPublishers: (publisherIds: string[]) => {
      update({ ...filter, publisherIds, page: 0 });
    },
    setPlatforms: (platformIds: string[]) => {
      update({ ...filter, platformIds, page: 0 });
    },
    setIabCategories: (iabCategoryIds: string[]) => {
      update({ ...filter, iabCategoryIds, page: 0 });
    },
    resetSecondaryFilters: () => {
      update({
        ...filter,
        publisherIds: defaultSupplyAppsListFilter.publisherIds,
        platformIds: defaultSupplyAppsListFilter.platformIds,
        iabCategoryIds: defaultSupplyAppsListFilter.iabCategoryIds,
        page: 0,
      });
    },
    setSort: (
      sortProperty: SupplyAppsSortProperty | null,
      sortDirection: SupplyAppsSortDirection,
    ) => {
      update({ ...filter, sortProperty, sortDirection, page: 0 });
    },
    setPagination: (page: number, size: number) => {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
  };
}
